export const LOADING_LOCALE_ZHCHS = {
    message: 'æ­£å¨å è½½ï¼è¯·ç¨å...'
};
